import { Component } from 'react';
import { connectTeamsTheme } from '../../../context/connectTeamsTheme';
import {
  ChevronDown32Filled as ChevronDownIcon,
  ChevronRight32Filled as ChevronRightIcon
} from '@fluentui/react-icons';
import { Button, Checkbox } from '@fluentui/react-components';
import { FacetValueCount, FacetValues, NumberFacetValue } from '../../../types/Facet';


interface NumberFacetTemplateProps {
  facetValues: FacetValueCount<NumberFacetValue>[];
  facetSelection: FacetValues<NumberFacetValue> |  null;
  displayName: string;
  onChangeFacet: (name: string, value: NumberFacetValue) => void;
  name: string;
  context: { style: number };
}

interface NumberFacetTemplateState {
  isExpanded: boolean;
}

class NumberFacetTemplate extends Component<NumberFacetTemplateProps, NumberFacetTemplateState> {
  constructor(props: NumberFacetTemplateProps) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  handleSectionExpand = () => this.setState(prevState => ({ isExpanded: !prevState.isExpanded }));

  render() {    
    if (!this.props.facetValues || this.props.facetValues.length < 0) {
        return null;
    }

    const facetValues = this.props.facetValues.sort((a, b) => a.facetValue.value - b.facetValue.value);
    const facetSelection = this.props.facetSelection;
    
    let checkboxes = facetValues.map((facetValue, index) => {
      
      const countDisplay = `(${facetValue.count})`;
      const isChecked = facetSelection?.facetValues.some(item => item.value === facetValue.facetValue.value);

      return (
        <li key={index + 1}>
          <Checkbox
            label={`${facetValue.facetValue.getStringValue()} ${countDisplay}`}
            checked={isChecked}
            onClick={() => this.props.onChangeFacet(this.props.name, facetValue.facetValue)}
          />
        </li>
      );
    });
    
    const { handleSectionExpand, state } = this;
    const { isExpanded } = state;
    const { style } = this.props.context;
    
    return (
      <section className={`search-fragment ${isExpanded ? 'expanded' : ''} ${style === 0 ? 'light' : ''}`}>
        <header className={facetSelection && facetSelection.facetValues.length > 0 ? 'active' : ''} onClick={() => handleSectionExpand()}>
          <Button
            appearance="transparent"
            icon={isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
          />
          {this.props.displayName}
        </header>
        <div className="support-content">
          <ul>
            {checkboxes}
          </ul>
        </div>
      </section>
    );
  }
}

const NumberFacet = connectTeamsTheme(NumberFacetTemplate);
export default NumberFacet;
